import { Link } from 'react-router-dom';

export default function SEOContentSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-stretch">
          <div className="lg:w-2/5">
            <div className="rounded-2xl overflow-hidden h-full min-h-[300px] md:min-h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20portrait%20style%20product%20photography%20of%20a%20person%20gently%20holding%20a%20tablet%20displaying%20colorful%20charts%20and%20spreadsheets%20while%20seated%20at%20a%20light%20marble%20cafe%20table%20with%20a%20ceramic%20latte%20cup%20nearby%20soft%20diffused%20natural%20window%20light%20from%20left%20side%20warm%20beige%20and%20cream%20tones%20editorial%20lifestyle%20aesthetic%20sophisticated%20relaxed%20atmosphere%20professional%20yet%20approachable&width=800&height=1000&seq=seo-content-v2-img-19&orientation=portrait"
                alt="Superbuy Spreadsheet user managing international shopping"
                title="Superbuy Spreadsheet Guide - International Shopping Management"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="lg:w-3/5 flex flex-col justify-center">
            <span className="text-xs font-medium text-accent-600 tracking-wider uppercase mb-3">
              &ldquo; The Ultimate Shopping Tool &rdquo;
            </span>

            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
              Why Thousands of Global Shoppers Trust{' '}
              <span className="text-primary-500">Superbuy Spreadsheet</span>
            </h2>

            <blockquote className="border-l-2 border-primary-300 pl-5 md:pl-6 mb-8">
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed italic">
                &ldquo;Before discovering the Superbuy Spreadsheet system, I was tracking my international orders across five different apps and a physical notebook. Now everything lives in one structured spreadsheet — product details, shipping costs, tracking numbers, and budget summaries. It fundamentally changed how I approach cross-border shopping. I estimate I have saved over $1,200 in shipping optimization alone in the past six months.&rdquo;
              </p>
              <footer className="mt-3 text-xs md:text-sm font-medium text-foreground-800">
                &mdash; Verified International Shopper, SuperbuySpread.hair Community
              </footer>
            </blockquote>

            <div className="flex flex-wrap gap-3">
              <Link
                to="/article/superbuy-spreadsheet-complete-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 text-xs md:text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span>Read Full Guide</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
              <Link
                to="/article/superbuy-spreadsheet-template-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-200 text-foreground-600 text-xs md:text-sm font-semibold rounded-full hover:bg-foreground-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span>Browse Templates</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-file-copy-line text-sm"></i>
                </div>
              </Link>
              <Link
                to="/article/superbuy-spreadsheet-shipping-guide"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-200 text-foreground-600 text-xs md:text-sm font-semibold rounded-full hover:bg-foreground-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <span>Shipping Savings</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-ship-line text-sm"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}